import * as React from 'react'
import { WrappedFieldMetaProps } from 'redux-form'
import { FormGroup, ControlLabel } from 'react-bootstrap'

export interface ControlWrapperProps {
  meta: WrappedFieldMetaProps
  children: React.ReactNode
  label?: string,
  name?: string
}

const ControlWrapper: React.SFC<ControlWrapperProps> = ({
  meta: { error, warning, touched },
  children,
  label,
  name
}) => {
  let message
  const validationState =
    (touched && (error && 'error')) || (warning && 'warning') || null

  if (touched && (error || warning)) {
    message = <span className="help-block">{error || warning}</span>
  }

  return (
    <FormGroup data-test={name != null ? `${name}-wrapper` : undefined} validationState={validationState}>
      {label && <ControlLabel>{label}</ControlLabel>}
      {children}
      {message}
    </FormGroup>
  )
}

export default ControlWrapper



// WEBPACK FOOTER //
// ./src/components/form/ControlWrapper.tsx